export const CAMPAIGN_SEND_RAILS = ['smtp', 'brevo_transactional'];
export const CAMPAIGN_SEND_RAIL_LABELS = {
    smtp: 'Eigen SMTP (mailbox)',
    brevo_transactional: 'Brevo transactional (geen mailbox)',
};
/** Default caps when not set on Brevo integration config. */
export const DEFAULT_BREVO_TRANSACTIONAL_DAILY_LIMIT = 200;
export const DEFAULT_BREVO_TRANSACTIONAL_HOURLY_LIMIT = 30;
export function parseBrevoTransactionalLimits(config) {
    const dailyRaw = config.transactional_daily_limit;
    const hourlyRaw = config.transactional_hourly_limit;
    const dailyLimit = typeof dailyRaw === 'number' && Number.isFinite(dailyRaw) && dailyRaw > 0
        ? Math.floor(dailyRaw)
        : DEFAULT_BREVO_TRANSACTIONAL_DAILY_LIMIT;
    const hourlyLimit = typeof hourlyRaw === 'number' && Number.isFinite(hourlyRaw) && hourlyRaw > 0
        ? Math.floor(hourlyRaw)
        : DEFAULT_BREVO_TRANSACTIONAL_HOURLY_LIMIT;
    return { dailyLimit, hourlyLimit };
}
//# sourceMappingURL=campaignSendRail.js.map